/**
 * Класс RoutingResult
 */
class RoutingResult {
    constructor(params) {
        this.result = {
            route: {
                geometry: params.route_geometry,
                instructions: params.route_instructions,
            },
            alternative: {
                geometry: params.alternative_geometries,
                instructions: params.alternative_instructions
            }
        }
    }
}

module.exports = RoutingResult;